import React from 'react';
import { Line } from 'react-chartjs-2';
import styles from './ModuleCSS/AnalysTest.module.css'

let test = 'Matilda';
const AnalysTest = (props) => {
  const data = {
    labels: ['08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00'],
    datasets: [
      {
        label: 'Promille',
        yAxisID: 'promille-left-y-axis',
        fill: false,
        lineTension: 0.3,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: '#000066',
        borderCapStyle: 'butt',
        borderWidth: 3,
        borderDashOffset: 0.0,
        borderJoinStyle: 'round',
        pointBorderColor: '#000066',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 10,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: [0.2, 0.4, 0.8, 1.9, 0.4, 0.1, 0.9, 0.7]
      }, {
        label: test,
        yAxisID: 'VAS-right-y-axis',
        fill: false,
        lineTension: 0.3,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: '#99CCFF',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'round',
        pointBorderColor: '#99CCFF',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 10,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: [8, 8, 7, 4, 2, 1, 4, 5]
    }, {
        label: 'Tröskelvärde',
        fill: true,
        lineTension: 0.1,
        backgroundColor: '#CCFFCC',
        borderColor: 'gray',
        borderCapStyle: 'butt',
        borderDash: [10, 5],
        borderDashOffset: 0.3,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 0.1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: [0.2, 0.2, 0.2, 0.2, 0.2, 0.2, 0.2, 0.2]
    }, {
      label: test,
      yAxisID: 'maende-y-axis',
      fill: false,
      lineTension: 0.1,
      
      backgroundColor: 'orange',
      borderColor: 'orange',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.3,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: 'orange',
      pointBorderWidth: 0.1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 0,
      pointRadius: 8,
      pointHitRadius: 10,
      borderWidth: 0,
      data: [null, null, 1, 1, 1, null, 1, 1]
  }

    ]
  };

  const options = { 
    scales: {
      yAxes: [{
        id: 'promille-left-y-axis',
        position: 'left',
          ticks: {
            suggestedMin: 0,
            suggestedMax: 2,
            /*
            callback: function(value, index, values) {
              return '$' + value;
          }
          */
        },
        scaleLabel: {
          display: true,
          labelString: 'promille'
      }
      }, {
        id: 'maende-y-axis',
        
        position: 'right',
        
          ticks: {
            display: false,
            
            suggestedMin: 0,
            suggestedMax: 18,
            /*
            callback: function(value, index, values) {
              return 'VAS' + value;
            
          }
          */
        },
          scaleLabel: {
          display: false,
          labelString: 'Promille'
      }
      }, {
        id: 'VAS-right-y-axis',
        position: 'right',
          ticks: {
            display: true,
            reverse: true,
            suggestedMin: 0,
            suggestedMax: 10,
            /*
            callback: function(value, index, values) {
              return 'VAS' + value;
            
          }
          */
        },
        scaleLabel: {
          display: true,
          labelString: 'Mående',
          color: 'blue'
        } 
      }]
    },
    title: {
      display: true,
      text: test,
      position: 'top',
      padding: 10
    },
    legend: {
      
    }
    };

  return (
    <div className={styles.container}>
        <div className={styles.top}>
            <h2>Analys</h2>
            <p>Matilda Nilsson (MANI)</p>
        </div>
      <div className={styles.messageBox}>
        <Line data={data} options={options} />
      </div>
    </div>
  );
};

export default AnalysTest;


  
  